import { render, staticRenderFns } from "./departments-section.vue?vue&type=template&id=50f0d369&scoped=true&"
import script from "./departments-section.vue?vue&type=script&lang=js&"
export * from "./departments-section.vue?vue&type=script&lang=js&"
import style0 from "./departments-section.vue?vue&type=style&index=0&id=50f0d369&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f0d369",
  null
  
)

export default component.exports